module.exports = __webpack_public_path__ + "static/media/play_i_500dpi_4276.03fde435.png";